import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import MultiLanguageCodeBlock from 'common/developers/docs/widget/MultiLanguageCodeBlock';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/changelog/_ChangelogPrivacyDocs.scss';

class ChangelogPrivacyDocs extends Component {
  static propTypes = {
    company: PropTypes.object,
  };

  render() {
    const { company } = this.props;
    const companyID = company?._id ? company._id : 'YOUR_APP_ID';
    return (
      <div className="changelogPrivacyDocs">
        <div className="title">Privacy</div>
        <div className="text">
          If your team wants to use Canny's changelog privately (eg. only exposing it to customers
          or teammates), you can still use the changelog widget.
        </div>
        <div className="text">
          There's just one additional step, in order to ensure your data stays safe. First generate
          an SSO token on your server, and then pass it in to our SDK when you initialize the
          changelog widget.
        </div>
        <div className="step">
          <div className="subheading">1. Generate an SSO token on your server</div>
          <div className="text">
            Follow steps on <Link to="/install/widget/sso">this page</Link> in order to generate SSO
            tokens on your server.
          </div>
        </div>
        <div className="step">
          <div className="subheading">2. Pass the SSO token into our SDK</div>
          <div className="text">
            Pass the server-generated SSO token into our SDK when you initialize the changelog
            widget. You can only initialize once, re-initializations may result in errors or
            unpredictable behaviour. Here's a snippet:
          </div>
          <MultiLanguageCodeBlock
            blocks={[
              {
                code: PositionAlignSnippet.replace('YOUR_APP_ID', companyID),
                language: 'js',
              },
            ]}
            showSelector={false}
          />
        </div>
      </div>
    );
  }
}

const PositionAlignSnippet = `Canny('initChangelog', {\n  appID: 'YOUR_APP_ID',\n  ssoToken: GENERATED_SSO_TOKEN,\n  position: 'bottom',\n  align: 'left',\n  theme: 'light', // options: light [default], dark, auto\n});`;

export default compose(
  withContexts({ company: DevelopersCompanyContext }),
  hot,
)(ChangelogPrivacyDocs);
